import * as React from "react";

import VitalsPage from "../../../vitals/pages/VitalsPage";

export default function VitalsStreamingPage() {
  return (
    <>
    {/* <PageShell
      title="Vitals Streaming"
      subtitle="Live vitals streams with charts, quality score, and alarm thresholds."
    /> */}
    <VitalsPage/>
    </>
  );
}